/** @jsx jsx */
import { jsx } from '@emotion/core';

import colors from '../../styles/colors';

import Logo from './Logo';
import Welcome from './Welcome';
import Initial from './Initial';
import { Link, withRouter } from 'react-router-dom';

// #region CSS

const headerStyles = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  backgroundColor: colors.grayDark,
  '@media print': {
    backgroundColor: '#fff',
    border: '1px solid #787694',
    borderRadius: 3,
    color: '#444',
    height: 84,
    marginTop: 24,
  },
};

const topBar = {
  alignItems: 'center',
  display: 'flex',
  height: 100,
  width: '100%',
};

const innerWrap = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  margin: '0 auto',
  maxWidth: 1144,
  padding: '0 24px',
  width: '100%',
};

const headerText = {
  color: colors.white,
  display: 'inline-flex',
  fontSize: 20,
  fontWeight: 600,
  letterSpacing: '.075em',
  marginLeft: 8,
  textTransform: 'uppercase',
  span: { paddingLeft: 6, fontWeight: 300 },
  '@media(max-width: 500px)': {
    flexDirection: 'column',
    span: { paddingLeft: 0 },
    lineHeight: '23px',
  },
  '@media print': { color: '#444' },
};

const rightSideWrap = {
  '@media(max-width: 500px)': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
};

const navBar = {
  width: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  borderTop: '1px solid rgba(255, 255, 255, 0.1)',
  '@media print': {
    display: 'none',
  },
};

const navBarInner = {
  margin: '0 auto',
  maxWidth: 1144,
  padding: '0 24px',
  display: 'flex',
  gap: 32,
};

const navLink = isActive => ({
  color: 'white',
  fontSize: 16,
  fontWeight: 500,
  padding: '16px 0',
  textDecoration: 'none',
  borderBottom: isActive ? '3px solid white' : '3px solid transparent',
  transition: 'all 0.2s ease',
  '&:hover': {
    borderBottomColor: 'white',
  },
});

// #endregion

const Header = ({ user, appName, location }) => {
  const currentPath = location.pathname;

  return (
    <div css={headerStyles}>
      <div css={topBar}>
        <div css={innerWrap}>
          <Link to="/">
            <div css={{ display: 'flex', alignItems: 'center' }}>
              <Logo />
              <h1 css={headerText}>
                Madison
                <span>{appName}</span>
              </h1>
            </div>
          </Link>
          <div css={rightSideWrap}>
            <Welcome name={user.name} />
            <Initial name={user.name} />
          </div>
        </div>
      </div>
      <div css={navBar}>
        <div css={navBarInner}>
          <Link to="/" css={navLink(currentPath === '/')}>
            Account Search
          </Link>
          {user.roles.includes('Admin') && (
            <Link to="/upload-bulk" css={navLink(currentPath === '/upload-bulk')}>
              Upload Accounts
            </Link>
          )}
          <Link to="/domain-verification" css={navLink(currentPath === '/domain-verification')}>
            Domain Verifier
          </Link>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Header);
